import { useState } from "react";
import emailjs from "emailjs-com";
import styled from "styled-components";
import { maisIntegridade, mapa, sisbi } from "../../assets/images";
import Footer from "../../components/footer";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { InputMask } from "primereact/inputmask";
import { Dropdown } from "primereact/dropdown";

import {
  BannerText,
  BannerWrapper,
  BoxImageContainer,
  BoxImageMaisIntegridade,
  BoxImageMapa,
  BoxImageSisbi,
  ContatosESelosContainer,
  HomeContainer,
  InfoContainerUm,
} from "./styles";
import { toast, ToastContainer } from "react-toastify";

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  background-color: #801818;
  color: white;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;

  label {
    font-weight: bold;
    margin-top: 10px;
  }

  input,
  select,
  textarea {
    margin-top: 5px;
    padding: 10px;
    border: none;
    border-radius: 5px;
    outline: none;
    font-size: 16px;
  }

  button {
    background-color: #f8c79a;
    color: #801818;
    border: none;
    padding: 12px;
    border-radius: 5px;
    font-weight: bold;
    margin-top: 20px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      opacity: 0.9;
    }
  }

  small {
    text-align: right;
    margin-top: 10px;
    font-size: 12px;
  }
`;

const Historia = () => {
  const [form, setForm] = useState({
    assunto: "",
    nome: "",
    cidade: "",
    email: "",
    whatsapp: "",
    mensagem: "",
  });

  const [errors, setErrors] = useState({
    assunto: "",
    nome: "",
    cidade: "",
    email: "",
    whatsapp: "",
    mensagem: "",
  });

  const [loading, setLoading] = useState(false);

  const assuntos = [
    { name: "Dúvidas", value: "Dúvidas" },
    { name: "Sugestões", value: "Sugestões" },
    { name: "Reclamações", value: "Reclamações" },
    { name: "Elogios", value: "Elogios" },
    { name: "Outros", value: "Outros" },
  ];

  // Handler for Dropdown
  const handleDropdownChange = (event: any) => {
    setForm({ ...form, assunto: event.value });
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const newErrors: typeof errors = {
      assunto: "",
      nome: "",
      cidade: "",
      whatsapp: "",
      email: "",
      mensagem: "",
    };
    if (!form.assunto) newErrors.assunto = "Assunto é obrigatório";
    if (!form.nome) newErrors.nome = "Nome é obrigatório";
    if (!form.cidade) newErrors.cidade = "Cidade/UF é obrigatório";
    if (!form.whatsapp) newErrors.whatsapp = "WhatsApp é obrigatório";
    if (!form.email) newErrors.email = "Email é obrigatório";
    if (!form.mensagem) newErrors.mensagem = "Mensagem é obrigatória";

    setErrors(newErrors);

    // retorna true se não houver nenhum erro
    return Object.values(newErrors).every((err) => err === "");
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return; // para o envio se houver erros

    setLoading(true);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID || "",
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
        form,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY || ""
      )
      .then(
        (result) => {
          toast.success("Mensagem enviada com sucesso!");
          setForm({
            assunto: "",
            nome: "",
            cidade: "",
            email: "",
            whatsapp: "",
            mensagem: "",
          });
        },
        (error) => {
          toast.error("Erro ao enviar a mensagem. Tente novamente.");
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };

  // Handler for InputMask
  const handleMaskChange = (event: any) => {
    setForm({ ...form, whatsapp: event.value });
  };

  return (
    <HomeContainer>
      <ToastContainer />
      <BannerWrapper>
        <BannerText>Fale Conosco</BannerText>
      </BannerWrapper>

      <InfoContainerUm>
        <FormContainer onSubmit={handleSubmit}>
          <label>Assunto*</label>
          <Dropdown
            value={form.assunto}
            onChange={handleDropdownChange}
            options={assuntos}
            optionLabel="name"
            placeholder="Selecione um assunto"
            className="w-full"
          />
          {errors.assunto && (
            <small style={{ color: "red" }}>{errors.assunto}</small>
          )}

          <label>Nome*</label>
          <InputText
            name="nome"
            value={form.nome}
            onChange={handleChange}
            placeholder="Digite seu nome"
          />
          {errors.nome && <small style={{ color: "red" }}>{errors.nome}</small>}

          <label>Cidade/UF*</label>
          <InputText
            name="cidade"
            value={form.cidade}
            onChange={handleChange}
            placeholder="Digite sua cidade/UF"
          />
          {errors.cidade && (
            <small style={{ color: "red" }}>{errors.cidade}</small>
          )}

          <label>Email*</label>
          <InputText
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Digite seu email"
          />
          {errors.email && (
            <small style={{ color: "red" }}>{errors.email}</small>
          )}

          <label>WhatsApp*</label>
          <InputMask
            name="whatsapp"
            value={form.whatsapp}
            onChange={handleMaskChange}
            mask="(99) 99999-9999"
            placeholder="(99) 99999-9999"
          />
          {errors.whatsapp && (
            <small style={{ color: "red" }}>{errors.whatsapp}</small>
          )}

          <label>Mensagem*</label>
          <InputTextarea
            name="mensagem"
            placeholder="Digite sua mensagem"
            value={form.mensagem}
            onChange={handleChange}
            rows={5}
            cols={30}
          />
          {errors.mensagem && (
            <small style={{ color: "red" }}>{errors.mensagem}</small>
          )}

          <button type="submit" disabled={loading}>
            {loading ? "Enviando..." : "Enviar Mensagem"}
          </button>
          <small>
            Os dados assinalados com * são de preenchimento obrigatório
          </small>
          <small>
            HORÁRIO DE ATENDIMENTO
            <br />
            Segunda - 09:00 às 17:00
            <br />
            Terça a sexta - 08:30 às 17:00
            <br />
            Não trabalhamos nos finais de semana e feriados.
          </small>
        </FormContainer>
      </InfoContainerUm>

      <ContatosESelosContainer>
        <BoxImageContainer>
          <BoxImageSisbi src={sisbi} alt="SISBI" />
          <BoxImageMaisIntegridade src={maisIntegridade} />
          <BoxImageMapa src={mapa} alt="Mapa" />
        </BoxImageContainer>
      </ContatosESelosContainer>
      <Footer />
    </HomeContainer>
  );
};
export default Historia;
